import C from 'actionTypes'

export const setRedirection = data => ({
  type: C.REDIRECTION,
  data
})

export default {
  setRedirection
}



// WEBPACK FOOTER //
// ./src/actions/client/redirection.js